"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _ArrowDownward = _interopRequireDefault(require("../internal/svg-icons/ArrowDownward"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _tableSortLabelClasses = _interopRequireWildcard(require("./tableSortLabelClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, direction = ownerState.direction, active = ownerState.active;
    var slots = {
        root: [
            'root',
            active && 'active',
            "direction".concat((0, _capitalize.default)(direction))
        ],
        icon: [
            'icon',
            "iconDirection".concat((0, _capitalize.default)(direction))
        ]
    };
    return (0, _composeClasses.default)(slots, _tableSortLabelClasses.getTableSortLabelUtilityClass, classes);
};
var TableSortLabelRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _define_property({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': _define_property({
            color: (theme.vars || theme).palette.text.secondary
        }, "& .".concat(_tableSortLabelClasses.default.icon), {
            opacity: 0.5
        })
    }, "&.".concat(_tableSortLabelClasses.default.active), _define_property({
        color: (theme.vars || theme).palette.text.primary
    }, "& .".concat(_tableSortLabelClasses.default.icon), {
        opacity: 1,
        color: (theme.vars || theme).palette.text.secondary
    }));
}));
var TableSortLabelIcon = (0, _zeroStyled.styled)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.icon,
            styles["iconDirection".concat((0, _capitalize.default)(ownerState.direction))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none',
        variants: [
            {
                props: {
                    direction: 'desc'
                },
                style: {
                    transform: 'rotate(0deg)'
                }
            },
            {
                props: {
                    direction: 'asc'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    };
}));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ var TableSortLabel = /*#__PURE__*/ React.forwardRef(function TableSortLabel(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    var _props_active = props.active, active = _props_active === void 0 ? false : _props_active, children = props.children, className = props.className, _props_direction = props.direction, direction = _props_direction === void 0 ? 'asc' : _props_direction, _props_hideSortIcon = props.hideSortIcon, hideSortIcon = _props_hideSortIcon === void 0 ? false : _props_hideSortIcon, _props_IconComponent = props.IconComponent, IconComponent = _props_IconComponent === void 0 ? _ArrowDownward.default : _props_IconComponent, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "active",
        "children",
        "className",
        "direction",
        "hideSortIcon",
        "IconComponent",
        "slots",
        "slotProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('root', {
        elementType: TableSortLabelRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref
    }), 2), RootSlot = _ref[0], rootProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('icon', {
        elementType: TableSortLabelIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.icon
    }), 2), IconSlot = _ref1[0], iconProps = _ref1[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({
        disableRipple: true,
        component: "span"
    }, rootProps, other), {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconSlot, _object_spread({
                as: IconComponent
            }, iconProps))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? TableSortLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */ active: _propTypes.default.bool,
    /**
   * Label contents, the arrow will be appended automatically.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The current sort direction.
   * @default 'asc'
   */ direction: _propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Hide sort icon when active is false.
   * @default false
   */ hideSortIcon: _propTypes.default.bool,
    /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */ IconComponent: _propTypes.default.elementType,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        icon: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        icon: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ])
} : void 0;
var _default = exports.default = TableSortLabel;
